var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FederationBox",staticStyle:{"cursor":"pointer"},style:({'border-color':_vm.borderColor})},[_c('div',{staticClass:"logo"},[_c('v-icon',{style:({'color':_vm.iconColor})},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('div',{staticClass:"company",style:({'background-color':_vm.bgColor}),domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }